import React from "react";
import review1 from '../../assets/images/review1.webp';
import review2 from '../../assets/images/review2.webp';
import review3 from '../../assets/images/review3.webp';
import review4 from '../../assets/images/review4.webp';
import review5 from '../../assets/images/review5.webp';
import review6 from '../../assets/images/review6.webp';
import review7 from '../../assets/images/review7.webp';
import review8 from '../../assets/images/review8.webp';

const trusted=[
  {
   Image:review1,
   name:"Willium Joy",
   position:"Smartbrain Tech",
   Paragraph: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapienteculpa, dolores ullam laudantium deleniti ipsa qui saepe voluptatumnam pariatur? Lorem ipsum dolor sit amet consectetur adipisicingelit. Neque, totam."
  },

  {
    Image:review2,
    name:"John Due",
    position:"Corporate Agency",
    Paragraph: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapienteculpa, dolores ullam laudantium deleniti ipsa qui saepe voluptatum nam pariatur? Lorem ipsum dolor sit amet consectetur adipisicing elit. Pariatur et, nemo distinctio eum omnis quam!"
   },

   {
    Image:review3,
    name:"Maria",
    position:"Company Inc",
    Paragraph: " Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente culpa, dolores ullam laudantium deleniti ipsa qui saepe voluptatum nam pariatur? Lorem ipsum dolor sit amet consectetur adipisicing elit. Pariatur et, nemo distinctio eum omnis quam!"
   },

   {
    Image:review4,
    name:"Willium Joy",
    position:"Smartbrain Tech",
    Paragraph: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente culpa, dolores ullam laudantium deleniti ipsa qui saepe voluptatum nam pariatur? Lorem ipsum dolor sit amet consectetur adipisicing elit. Neque, totam."
   },

   {
    Image:review5,
    name:"Willium Joy",
    position:"Smartbrain Tech",
    Paragraph: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapienteculpa, dolores ullam laudantium deleniti ipsa qui saepe voluptatumnam pariatur? Lorem ipsum dolor sit amet consectetur adipisicingelit. Neque, totam."
   },

   {
    Image:review6,
    name:"John Due",
    position:"Corporate Agency",
    Paragraph: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapienteculpa, dolores ullam laudantium deleniti ipsa qui saepe voluptatum nam pariatur? Lorem ipsum dolor sit amet consectetur adipisicing elit. Pariatur et, nemo distinctio eum omnis quam!"
   },

   {
    Image:review7,
    name:"Maria",
    position:"Company Inc",
    Paragraph: " Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente culpa, dolores ullam laudantium deleniti ipsa qui saepe voluptatum nam pariatur? Lorem ipsum dolor sit amet consectetur adipisicing elit. Pariatur et, nemo distinctio eum omnis quam!"
  },

   {
    Image:review8,
    name:"Willium Joy",
    position:"Smartbrain Tech",
    Paragraph: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapienteculpa, dolores ullam laudantium deleniti ipsa qui saepe voluptatumnam pariatur? Lorem ipsum dolor sit amet consectetur adipisicingelit. Neque, totam."
   },

]

const Positive =()=>{
    return(
        <>
        <section className="review_section row_am page_ban">
  <div className="container">
    <div className="section_title" data-aos="fade-up" data-aos-duration={1500}>
      <span className="title_badge">Reviews</span>
      <h2>Words from trusted peoples </h2>
      <p>
        Lorem Ipsum is simply dummy text of the printing indus orem Ipsum has
        been the industrys standard dummy text ever since.
      </p>
    </div>
    <div className="positive_inner in_page">
      <div className="row">
        <div className="review_side innerpage_block">
        {trusted.map((data, index) =>
          <div key={index}
            className="review_block"
            data-aos="fade-up"
            data-aos-duration={1500}
          >
            
            <div className="star">
              <span>
                <i className="icofont-star" />
              </span>
              <span>
                <i className="icofont-star" />
              </span>
              <span>
                <i className="icofont-star" />
              </span>
              <span>
                <i className="icofont-star" />
              </span>
              <span>
                <i className="icofont-star" />
              </span>
            </div>
            <p>
              {data.Paragraph}
            </p>
        
            <div className="coustomer_info">
              <div className="avtar">
                <img src={data.Image} alt="image" />
                <div className="text">
                  <h6>{data.name}</h6>
                  <span>{data.position}</span>
                </div>
              </div>
            
              <div className="quote">
                <i className="icofont-quote-right" />
              </div>
            </div>
          </div>
        )}  
        </div>
      </div>
    </div>
  </div>
</section>

        
        </>
    )
}
export default Positive;